










import Vue from 'vue';
import { mapGetters } from 'vuex';

export default Vue.extend({
    name: 'Copyright',
    props: {
        withLink: {
            type: Boolean,
            default: false,
        }
    },
    computed: {
        ...mapGetters('app', {
            copyright: 'getCopyright',
            copyrightLink: 'getCopyrightLink',
        }),
    },
});
